<template>
  <div v-if="show">

    <div class="PopUpResetPass">
      <div class="PopUpFon"></div>
      <div class="PopUpPanel">
        <div class="PopUpBlock">
          <div class="PopUpName">Новый пароль</div>
          <div class="PopUpClose" @click="hide()"></div>

          <form method="post" @submit.prevent="submit">
            <span class="form_error" v-show="error">{{ error }}</span>
            <div class="PassNew">
              <input type="text" name="password" placeholder="Ваш пароль" v-model="password"><br>
              <span class="form_error" v-show="errors.password">{{ errors.password }}</span>
            </div>
            <div class="PassAgain">
              <input type="text" name="password_confirmation" placeholder="Еще раз" v-model="password_confirmation">
              <span class="form_error" v-show="errors.password_confirmation">{{ errors.password_confirmation }}</span>
            </div>

            <input type="submit" class="BtEnter" value="Сохранить">
          </form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { omit } from 'lodash';
import { API_ROOT } from "@/utils/api_root";

export default {
  props: {
    show: { type: Boolean, default: function() { return false; } },
    token: { type: String, default: function() { return ""; } },
  },
  data() {
    return {
      password: null,
      password_confirmation: null,
      errors: {},
      error: null
    };
  },
  computed: {
  },
  methods: {
    hide() {
      this.show = false;
      this.goTo('home');
    },
    submit() {
      console.log('this.password', this.password);
      this.error = null;
      this.errors = {};
      if (!this.password) {
        this.errors = {password: "Укажите пароль"}  ;
        return;
      }

      const params = { password: this.password, password_confirmation: this.password_confirmation, reset_password_token: this.token };
      this.$http.put(`${API_ROOT}/auth/password`, params)
        .then(response => {
          console.log('PasswordReset success', response);
          this.$store.commit('currentUser', response.data.data);
          this.flash('Ваш пароль успешно обновлён', 'success', {timeout: 3000});
          this.show = false;
          this.goTo('id');
        })
        .catch(error => {
          console.log('PasswordReset error', error, error.response.data.errors);
          const responseErrors = error.response.data.errors;
          if (Array.isArray(responseErrors)) {
            this.error = responseErrors.join(", ");
          } else {
            this.errors = Object.fromEntries(
                                  Object.entries(responseErrors)
                                    .map(([k, v]) => {
                                      return [k, v.join(", ")];
                                    })
                                );
          }
        });
    }
  }
};
</script>

<style>
.PopUpResetPass{
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.PopUpResetPass form div{
  position: absolute;
}

.PopUpResetPass form input:not([type="submit"]){
  color: #000;
}
</style>
